import { Grid2 } from '@mui/material';
import React, { useEffect } from 'react';
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import InputRut from '../../../../components/inputs/yup/materialui/inputRut';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { FilterList } from '@mui/icons-material';
import { Control, FieldErrors, FieldValues, UseFormWatch } from 'react-hook-form';
import { useComunMinvu } from '../hooks/useComunMinvu';
import { Dominios } from '../../../../utils/enums';
import Conversiones from '../../../../utils/conversiones';

export interface IFilter {
    numeroOperacion?: string;
    rut?: string;
    nombre?: string;
    tipoBeneficio: string;
    estado?: string | null;
    fechaDesde?: string | null;
    fechaHasta?: string | null;
}

export interface IProps {
    control: Control<IFilter, any>
    errors: FieldErrors<IFilter>;
    watch: UseFormWatch<IFilter>
    estadoParaListar: Dominios;
}

const FiltrosComun: React.FC<IProps> = ({ control, errors, watch, estadoParaListar }) => {

    const { listaBeneficios, listaEstado, beneficios, estado } = useComunMinvu();
    const { fechaDesde, fechaHasta } = watch();

    useEffect(() => {
        listaBeneficios();
        listaEstado(estadoParaListar);
        // eslint-disable-next-line
    }, []);



    return (
        <Grid2 container spacing={2}>
            <Grid2 size={3}>
                <InputText
                    name="numeroOperacion"
                    control={control}
                    error={errors?.numeroOperacion}
                    label="N° operación"
                />
            </Grid2>
            <Grid2 size={3}>
                <InputRut
                    name="rut"
                    control={control}
                    error={errors?.rut}
                    label="RUT"

                />
            </Grid2>
            <Grid2 size={3}>
                <InputText
                    name="nombre"
                    control={control}
                    error={errors?.nombre}
                    label="Nombre"

                />
            </Grid2>
            <Grid2 size={3}>
                <InputSelect
                    name="tipoBeneficio"
                    control={control}
                    error={errors?.tipoBeneficio}
                    label="Tipo beneficio"
                    options={beneficios}
                />
            </Grid2>
            <Grid2 size={3}>
                <InputSelect
                    name="estado"
                    control={control}
                    label="Estado"
                    error={errors?.estado}
                    options={estado}
                />
            </Grid2>
            <Grid2 size={3}>
                <InputFecha
                    name="fechaDesde"
                    control={control}
                    label="Fecha desde"
                    error={errors?.fechaDesde}
                    fecha={Conversiones.parseLocalDate(fechaDesde)}
                />
            </Grid2>
            <Grid2 size={3}>
                <InputFecha
                    name="fechaHasta"
                    control={control}
                    label="Fecha hasta"
                    error={errors?.fechaHasta}
                    fecha={Conversiones.parseLocalDate(fechaHasta)}
                />
            </Grid2>

            <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                    Filtrar
                </MButton>
            </Grid2>
        </Grid2>
    );
};

export default FiltrosComun;